
import React from "react";
import { Brain } from "lucide-react";

const AgenticAICapabilitiesSection = () => {
  return (
    <section className="py-16 bg-slate-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Spharaka <span className="text-[#8932c8]">XDR Capabilities</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our XDR platform delivers autonomous investigation capabilities and precision-driven automated responses that transform security operations through intelligent threat correlation and contextual analysis.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-white rounded-xl overflow-hidden shadow-md">
            <div className="p-8">
              <h3 className="text-2xl font-bold mb-4">Automated XDR Investigation & Analysis</h3>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <div className="mr-3 mt-1 text-[#8932c8]">•</div>
                  <p>Automatically conducts deep XDR investigations across multiple attack vectors, examining patterns, IOCs, and contextual threat intelligence with precision</p>
                </li>
                <li className="flex items-start">
                  <div className="mr-3 mt-1 text-[#8932c8]">•</div>
                  <p>Correlates security events across endpoints, networks, cloud workloads, and applications to build complete multi-vector attack timelines</p>
                </li>
                <li className="flex items-start">
                  <div className="mr-3 mt-1 text-[#8932c8]">•</div>
                  <p>Integrates real-time threat intelligence feeds with behavioral analytics to identify sophisticated attack patterns and TTPs</p>
                </li>
                <li className="flex items-start">
                  <div className="mr-3 mt-1 text-[#8932c8]">•</div>
                  <p>Reconstructs complete attack kill chains with forensic-grade precision, providing comprehensive visibility into threat actor methodology</p>
                </li>
              </ul>
            </div>
            <div className="bg-slate-800 p-8">
              <div className="flex items-center mb-4">
                <Brain className="h-6 w-6 text-[#8932c8] mr-2" />
                <h4 className="text-lg font-semibold text-white">Autonomous XDR Investigation</h4>
              </div>
              <p className="text-slate-300">
                Our XDR platform autonomously investigates complex multi-vector attacks, following digital breadcrumbs across endpoints, networks, and cloud environments while gathering forensic evidence with precision that dramatically reduces investigation time from hours to minutes.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-xl overflow-hidden shadow-md">
            <div className="p-8">
              <h3 className="text-2xl font-bold mb-4">Precision XDR Response & Orchestration</h3>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <div className="mr-3 mt-1 text-[#8932c8]">•</div>
                  <p>Prioritizes threats using advanced risk scoring algorithms that evaluate business impact, attack sophistication, and lateral movement potential</p>
                </li>
                <li className="flex items-start">
                  <div className="mr-3 mt-1 text-[#8932c8]">•</div>
                  <p>Orchestrates precision response actions across the entire security stack based on threat context, organizational policies, and attack progression analysis</p>
                </li>
                <li className="flex items-start">
                  <div className="mr-3 mt-1 text-[#8932c8]">•</div>
                  <p>Automatically executes surgical containment actions to neutralize threats while minimizing business disruption and false positive noise</p>
                </li>
                <li className="flex items-start">
                  <div className="mr-3 mt-1 text-[#8932c8]">•</div>
                  <p>Provides forensic-grade audit trails and detailed explanations for all automated decisions and response actions to ensure transparency and compliance</p>
                </li>
              </ul>
            </div>
            <div className="bg-slate-800 p-8">
              <div className="flex items-center mb-4">
                <Brain className="h-6 w-6 text-[#8932c8] mr-2" />
                <h4 className="text-lg font-semibold text-white">Precision Response Engine</h4>
              </div>
              <p className="text-slate-300">
                Our XDR platform continuously refines response precision through machine learning, adapting containment strategies based on attack patterns and environmental context to deliver surgical threat neutralization with minimal operational impact.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AgenticAICapabilitiesSection;
